
const color = {
    primary: '#fd0167',
    primaryLight: '#FFDFEC',
    primaryDark: '#DD015A',
 
    lightGrey: '#989898',
    grey: '#919191',
    greyShade1: '#5f5f5f',
    greyShade2: '#5c5c5c',
    greyShade3: '#848484',
    greyShade4: '#DBDBDB',
    greyShade5:"#6c757d",
    darkGrey: '#616161',

    brown: '#cda46f',
    brownShade4: '#a37032',

    brownShade3: '#DFCBB2',
    brownShade2: '#ffe8cb',
    brownShade1: '#c19052',
    lightBrown: '#ffefda',

    maroon: '#bc0404',

    darkBlue: '#4169e2',

    lightPink: '#dc7092',
    purple: '#dc2a92',
    lightPurple: '#cabdcd',
    green: '#6da400',
    greenShade1: '#6aaf89',

    yellow: '#fbd34b',
    darkYellow: '#FFD95A',
};

export default color;
